/*
 DaneZbierane

 Tresc polityki prywatnosci Dane zbierane i przetwarzane przez aplikację dla wszystkich aplikacji 
  
 historia: 
  PM 2021-09-07 - start
*/

import * as React from 'react';

import { Typography } from '@material-ui/core';

interface DaneZbieraneProps {
    sms?: boolean
}

class DaneZbierane extends React.Component<DaneZbieraneProps, any> {

    //PM 2021-11-05
    //variant='body2'
    //poprawka DOM
    render() {

        return (
            <React.Fragment>
                <Typography variant='body2'><b>Dane zbierane i przetwarzane przez aplikację</b></Typography>
                <Typography variant='body2'>
                    Aplikacja mobilna zbiera dane diagnostyczne takie jak nazwa i model danego urządzenia mobilnego, wersja systemu Android, wersja aplikacji mobilnej, lokalny adres IP użytkownika, status zalogowania do aplikacji mobilnej, a także nazwa aktywnego połączenia sieciowego (w urządzeniach mobilnych z systemem Android starszym niż Android 6.0). Dane te są wykorzystywane w raportach awarii w celu lepszej diagnozy błędów i poprawy jakości aplikacji.
                </Typography>
                {this.props.sms ?
                    (
                        <Typography variant='body2'>
                            Aplikacja zbiera również zanonimizowane dane dotyczące treści wiadomości sms otrzymywanych na urządzeniu, na którym jest zainstalowana. Jako aplikacja będąca instalowana na urządzeniu służącym do wysyłki wiadomości do klientów i przekierowywująca błędnie zaadresowane wiadomości na urządzenie na którym jest zainstalowana do samych klientów, aplikacja zbiera same treści otrzymanych wiadomości, które zostały rozpoznane przez algorytm generujący automatyczne odpowiedzi w celu rozwoju algorytmu automatycznych odpowiedzi. Informacje dotyczące nadawcy i adresata nie są magazynowane, a jedynie treści wiadomości otrzymanych podczas pracy aplikacji.
                        </Typography>
                    ) : null}
            </React.Fragment>
        );
    }
}

export default DaneZbierane;
